import MenuCard from '../MenuCard/MenuCard'
import './CardColumn.css'

export default function CardColumn({ column }) {
  // console.log(`CardColumn rendered: ${column.number} - ${column.width}%`)

  let cards = []
  let columnStyle = {
    width: `${column.width}% `,
    verticalAlign: 'top'
  }

  if (column.cards) {
    column.cards.forEach((card) => {
      cards.push(<MenuCard key={card.id} card={card} />)
    })
  }

  return (
    <div className="card-column" style={columnStyle}>
      {cards}
    </div>
  )
}
